<div class="sidebar-wrapper" [ngClass]="{'side-panel-notes': openNotesTab}">
  <p-sidebar
    styleClass="p-sidebar-md"
    dismissible="false"
    blockScroll="false"
    cache="false"
    [showCloseIcon]="false"
    [dismissible]="false"
    [(visible)]="sideBarVisible"
    (onHide)="handleHideSidebar()"
    position="right"
    baseZIndex="9"
  >
    <div class="sidebar-container" #sidebarContainer>

      <div *ngIf="!openNotesTab">
        <i id="sidebar-close-icon" class="fal fa-times sidebar-close-icon" (click)="handleCloseSidebar()"></i>

        <div class="flex-between-center width-93p mt-2">
          <div class="flex-start-center">
            <!-- <div class="flex-start-center sidebar-customer-name pointer ml-1 customer-center-hover" (click)="navigateToCustomerCenter()">
              <i class="pr-2 far fa-user"></i>
              <span class="pr-6p text-truncate font-20 font-bold text-truncate" [ngClass]="{ 'text-ellipse': supplier?.name?.length >= 35 }">
                {{ supplier?.name }}
              </span>
              <i class="fal fa-external-link font-bold"></i>
            </div> -->
            <div class="flex-start-center sidebar-customer-name">
              <i class="pr-2 far fa-user"></i>
              <span class="text-truncate font-20 font-bold text-truncate" [ngClass]="{ 'text-ellipse': supplier?.name?.length >= 35 }">
                {{ supplier?.name }}
              </span>
              <!-- <i class="fal fa-external-link font-bold"></i> -->
            </div>
            <div>
              <span class="supplier-tag" [ngStyle]="{backgroundColor: supplier.tagColor}">
                {{supplier?.type?.name}}
              </span>
            </div>
          </div>

          <div class="customer-active-switch">
            <app-switch-pill
              id="sidebar-customer-active-switch"
              position="end"
              [label]="supplier?.isActive ? 'Active' : 'Inactive'"
              [isActive]="supplier?.isActive"
              (appChange)="handleSwitchChange($event)"
              [disabled]="supplier.archive"
            >
            </app-switch-pill>
          </div>
        </div>

        <!-- Chat icon -->
        <div *ngIf="isAccountPayablePayment" class="flex-end-center acc-payment">
          <p>Amount payable: <strong>{{(supplier.totalPayable || 0) | currency: 'USD'}}</strong></p>
        </div>
        <p-tabView *ngIf="!isLoading" class="tab-panel-underline sidebar-scroll tab-panel-default" (onChange)="handleTabChange($event)" [activeIndex]="index">
          <p-tabPanel id="sidebar-tab-personal" header="Profile">
            <ng-template pTemplate="content">
              <app-supplier-update
              [customerId]="customer?._id"
                [supplier]="supplier"
                (supplierUpdate)="supplierUpdate($event)"

              >
              </app-supplier-update>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>

      <div *ngIf="openNotesTab">
        <i id="notes-close-icon" class="fal fa-times notes-close-icon" (click)="handleCloseSidebar()"></i>

        <div class="flex-between-center width-93p mt-2">
          <div class="flex-start-center">
            <div class="flex-start-center sidebar-customer-notes pointer ml-1">
              <span class="notes-circle">
                <i class="pr-2 fad fa-sticky-note notes-icon font-18"></i>
              </span>
              <span class="pr-6p font-18 font-black font-bold notes-heading">
                {{notePanelData?.title}}
              </span>
            </div>
          </div>
        </div>

        <!-- <hr class="notes-underline">

        <div class="notes-textarea">
          <app-textarea class="cursor-text " type="text" name="notes" textAreaId="sidebar-custom-notes"
            styleClassLabel="cursor-text" styleClass="service-notes"
            styleClassInput="" theme="light" [placeholder]="notePanelData?.title" [rows]="1" [hasHoverEffect]="false" [autoGrow]="true"
            [maxAutoGrowHeight]="810" [value]="notePanelData?.notes" [maxLength]="2000"
            [fontSize]="14" (appFocus)="handleFocus('notes')" (appChange)="handleChange('notes', $event)">
          </app-textarea>
        </div> -->

        <div class="set-notes-dialog-footer flex-end-center">
          <button class="btn btn-border pointer btn-submit mr-2" (click)="handleCloseSidebar()">Cancel</button>
          <button class="btn btn-primary btn-submit mr-2" (click)="saveNotes()">
            Save
          </button>
        </div>

      </div>
    </div>
  </p-sidebar>
</div>
